const i18n = {
  'zh-CN': {
    pleaseEnter: '请输入',
    currentValueDuplicate: '当前值重复',
    minMaxLength: '{name}为{minLength} ~ {maxLength}个字符',
    numberLength: '整数最大允许{integerMaxDigits}位,小数最大允许{decimalMaxDigits}位',
    pleaseEnterTheNumber: '请输入数字',
    lessThanTheMinimum: '请输入大于{minValue}的数值',
    lessThanOrEqualToTheMinimum: '请输入大于等于{minValue}的数值',
    greaterThanTheMaximum: '请输入小于{maxValue}的数值',
    greaterThanOrEqualToTheMaximum: '请输入小于等于{maxValue}的数值',
    integersAreAllowedToHaveMaximum: '整数最大允许14位,小数最大允许8位',
    thereHasBeenSuch: '已存在该',
    theFileIsStillBeingUploaded: '文件还在上传中',
    theImgIsStillBeingUploaded: '图片还在上传中',
    pleaseSelectStartDate: '请选择开始日期',
    pleaseSelectEndDate: '请选择结束日期',
    theEndTimeCannotBeLessThanTheStartTime: '结束时间不能小于开始时间',
    mainFile: '个文件',
    FileSelectionPleaseReselectMaximumSupportUploading: '文件选择错误，请重新选择，最大支持上传{maxSize}M大小',
    FileSelectionErrorPleaseReselectOnlySupport: '仅支持{fileType}格式',
    MaximumAllowedUpload: '最多允许上传'
  },
  'en': {
    pleaseEnter: 'Please enter ',
    currentValueDuplicate: 'Value repeats',
    minMaxLength: '{name} Please enter within {minLength} ~ {maxLength} characters',
    numberLength: 'The maximum number of integers is {integerMaxDigits}, and the maximum number of decimals is {decimalMaxDigits}',
    pleaseEnterTheNumber: 'Please enter a number',
    lessThanTheMinimum: 'Please enter a number greater than {minValue}',
    lessThanOrEqualToTheMinimum: 'Please enter a number greater than or equal to {minValue}',
    greaterThanTheMaximum: 'Please enter a number greater than or equal to {maxValue}',
    greaterThanOrEqualToTheMaximum: 'Please enter a number value less than or equal to {maxValue}',
    integersAreAllowedToHaveMaximum: 'A maximum of 14 bits are allowed for integers and 8 bits for decimals',
    thereHasBeenSuch: 'The one already exists',
    theFileIsStillBeingUploaded: 'The file is still uploading',
    theImgIsStillBeingUploaded: 'The picture is still uploading',
    pleaseSelectStartDate: 'Please select the start date',
    pleaseSelectEndDate: 'Please select the end date',
    theEndTimeCannotBeLessThanTheStartTime: 'The end time cannot be less than the start time',
    mainFile: '个文件',
    FileSelectionPleaseReselectMaximumSupportUploading: 'The file selection is incorrect, please select again, the maximum size of {maxSize}M can be uploaded',
    FileSelectionErrorPleaseReselectOnlySupport: 'Only the {fileType} format is supported',
    MaximumAllowedUpload: 'A maximum of {maxUploadNum} files can be uploaded'
  }
}
export default i18n
